import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';

const APP_STORE_URL = 'https://apps.apple.com/ng/app/bilalsadasub/id6449217719';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.bilalsadasub';

// Both badges rendered at the same visual HEIGHT. Apple badge has padding
// baked in; Google's includes the outer "border" margin so we trim by
// rendering it slightly taller to optically match Apple.
const BADGE_HEIGHT = 42;

export default function StoreBadges({ caption, sx, justifyContent = 'center' }) {
  return (
    <Stack spacing={1.25} sx={{ alignItems: justifyContent === 'flex-start' ? 'flex-start' : 'center', ...sx }}>
      {caption && (
        <Typography
          sx={{
            fontSize: '0.72rem',
            color: 'text.secondary',
            fontWeight: 500,
            letterSpacing: '0.02em',
          }}
        >
          {caption}
        </Typography>
      )}
      <Stack direction="row" spacing={1} justifyContent={justifyContent} flexWrap="wrap" alignItems="center">
        <Box
          component="a"
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Download Bilalsadasub on the App Store"
          sx={{
            display: 'inline-flex',
            transition: 'opacity 0.18s ease, transform 0.18s ease',
            '&:hover': { opacity: 0.85, transform: 'translateY(-1px)' },
          }}
        >
          <Box
            component="img"
            src="/badges/app-store.svg"
            alt="Download on the App Store"
            sx={{ height: BADGE_HEIGHT, display: 'block' }}
          />
        </Box>
        <Box
          component="a"
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Get Bilalsadasub on Google Play"
          sx={{
            display: 'inline-flex',
            transition: 'opacity 0.18s ease, transform 0.18s ease',
            '&:hover': { opacity: 0.85, transform: 'translateY(-1px)' },
          }}
        >
          <Box
            component="img"
            src="/badges/google-play.png"
            alt="Get it on Google Play"
            sx={{ height: BADGE_HEIGHT + 14, display: 'block', mt: '-7px', mb: '-7px' }}
          />
        </Box>
      </Stack>
    </Stack>
  );
}

StoreBadges.propTypes = {
  caption: PropTypes.string,
  sx: PropTypes.object,
  justifyContent: PropTypes.string,
};
